import Converter from './Converter';
import { shortLanguages } from 'services/locale';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  authRequired: false,
  gameListUrl: `redrake/game/list?partner_name=${projectName}`,
  sessionUrlData: {
    url: 'redrake/frame_url',
    method: QueryTypes.GET,
    getBody: params => ({
      gameid: params.gameId,
      lang: shortLanguages[params.lang as keyof typeof shortLanguages],
      urlhome: location.origin,
    }),
    getHeaders: () => ({
      headers: {
        'x-partner-name': projectName,
        'x-partner-authorization': parseCookies(),
      },
    }),
    converter: converter.convertGameUrl,
  },
  converter,
};
